import axios from "axios";
import Cookies from "universal-cookie";
const apiUrl = process.env.REACT_APP_API_URL;

const cookies = new Cookies();

export const donateApi = async (
  amount: number,
  details: any[],
  token: string,
  transactionType: number,
  userId?: string | null,
  bankId?: string | null,
  donatedOn?: string | null,
  referenceNumber?: string | null,
  boxId?: string | null,
  receviedUserId?: string | null,
  bankStatementId?: string,
): Promise<any> => {
  try {
    
    const response = await axios.post(
      `${apiUrl}/donation/create`,
      {
        amount,
        donationDetails: details,
        transactionType,
        userId: userId ?? null,
        bankId: bankId ?? null,
        donatedOn: donatedOn ?? null,
        referenceNumber: referenceNumber ?? null,
        boxId: boxId ?? null,
        ReceivedBy: receviedUserId ?? null,
        bankStatementId: bankStatementId ?? null
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};


function serializeParams(params: Record<string, any>): string {
  const query: string[] = [];
  for (const key in params) {
    if (params[key] === undefined || params[key] === null) continue;
    if (Array.isArray(params[key])) {
      params[key].forEach((val: any) => {
        query.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
      });
    } else {
      query.push(`${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);
    }
  }
  return query.join("&");
}

export const donateHistoryApi = async (
  url: string,
  transactionTypes?: (string)[],
  donationType?: string,
  purposeType?: string,
  year?: string,
  month?: string,
  search?: string,
  pageNumber?: number,
  pageSize?: number,
  ezpayStatus?: string,
  unassignedFilter?: string
): Promise<any> => {
  const token = cookies.get("authToken");
   
  try {
    const params = {
      transactionTypes: transactionTypes?.length ? transactionTypes : undefined,
      donationType: donationType || undefined,
      purposeType: purposeType || undefined,
      year: year || undefined,
      month: month || undefined,
      searchTerm: search !== undefined && search !== null ? search : undefined,
      pageNumber: pageNumber !== undefined ? pageNumber : undefined,
      pageSize: pageSize !== undefined ? pageSize : undefined,
      ezpayStatus: ezpayStatus || undefined,
      unassignedFilter: unassignedFilter || undefined,
    };

    const queryString = serializeParams(params);

    const response = await axios.get(
      `${url}/donation/get${queryString ? "?" + queryString : ""}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const donateHistoryByUserIdApi = async () => {
  const token = cookies.get('authToken');
  try {
    const response = await axios.get(`${apiUrl}/donation/getbyuserid`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return false;
  }
};

export const getDonationByIdApi = async (
  Id: string,
  url: string
): Promise<any> => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.get(`${url}/donation/GetById`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        Id,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);

    return false;
  }
};
export const donationUpdateApi = async (
  url: string,
  Id: string,
  amount: number,
  details: any[],
  transactionType: number,
  userId?: string | null,
  bankId?: string | null,
  donatedOn?: string | null,
  referenceNumber?: string | null,
  boxId?: string | null,
  receviedUserId?: string | null
): Promise<any> => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.post(
      `${url}/donation/update`,
      {
        Id,
        amount,
        donationDetails: details,
        transactionType,
        userId: userId ?? null,
        bankId: bankId ?? null,
        donatedOn: donatedOn,
        referenceNumber: referenceNumber ?? null,
        boxId: boxId ?? null,
        ReceivedBy: receviedUserId ?? null
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};
export const getReceiptDonationById = async (id: string) => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.get(`${apiUrl}/Donation/get-receipt`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        id,
      },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const transactionStatusApi = async (Id: string) => {
  const token = cookies.get('authtoken');
  try {
    const response = await axios.get(`${apiUrl}/api/Transaction/${Id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        Id,
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getDonationTPApi = async (donationTP: string) => {
  const token = cookies.get('authToken')
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/donationtypepurpose/get`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return false;
  }
};

export const DonationVerifyApi = async (url: string, referenceId: number): Promise<any> => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.post(`${url}/Ezpay/response/verify`,
      {
        ReferenceId: referenceId
      }, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error verifying donation:", error);
    throw error;
  }
};


export const deleteDonationApi = async (url: string, id: string) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.post(
      `${url}/donation/delete`,
      {
        id: id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const FetchDonationDetails_SPByYearAndMonth = async (
  url: string,
  year: number | null,
  month: number | null
): Promise<any> => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.get(`${url}/donation/fetchdonationdetailsbyyear&month`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        year: year ?? null,
        month: month ?? null,
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);

    return false;
  }
};


export const updateBankStatementIdDonation = async (selectedDonationKeys: number[], bankstatementId: string) => {

  const token = cookies.get('authToken');
  try {
    const response = await axios.patch(`${apiUrl}/donation/updateBankstatementId`,
      {
        ReferenceIds: selectedDonationKeys,
        bankStatementId: bankstatementId
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};




export const getAssingedDonations = async (Id: string): Promise<any> => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.get(`${apiUrl}/donation/getassigneddonations/${Id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const UnAssignBSIdDonations = async (Id: string) => {
  const token = cookies.get('authToken');
  try {
    const response = await axios.post(`${apiUrl}/donation/unAssignBankstatementId/${Id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch (error) {
    console.error(error);
    throw error;
  }
};